import { Typography } from "@mui/material";

const SectionTitle = ({ ...props }) => {
  const { title, subtitle, sx } = props;
  let SxProps = {
    fontSize: "1.125rem",
    color: "black",
    fontWeight: "bold",
    mb: "1em",
    borderBottom: "1px solid #d5d5d5",
    pb: "15px",
  };
  if (sx) {
    SxProps = { ...SxProps, ...sx };
  }
  return (
    <>
      <Typography variant="h3" sx={SxProps}>
        {ucFirst(title)}{" "}
        {subtitle && (
          <span style={{ fontSize: "14px", marginLeft: "20px" }}>
            ({subtitle})
          </span>
        )}
      </Typography>
    </>
  );
};
const ucFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export default SectionTitle;
